var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.componentName
    ? _c(_setup.componentName, {
        tag: "component",
        attrs: {
          "current-data": _setup.currentData,
          field: _vm.field,
          "form-id": _vm.formId,
          value: _setup.currentData[_vm.field.name],
        },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }